import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { DispatchDatahubEvents } from '../../components/moduleCard/actions/dispatchDatahubEvents';
import { isApiValidationError } from 'src/config/request/fetcher/error';
import { contentListQueries } from 'src/modules/contentList/queries';
import { BulkActionService } from 'src/modules/contentList/services';
import { Toast } from 'src/shared/components/toast';
export function useDeleteModule(module) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const deleteMutation = useMutation({
        mutationFn: BulkActionService.delete,
        onSuccess: () => {
            setShowDeleteConfirmation(false);
            Toast.show({ type: 'success', message: t('content_list.delete_module.success') });
            queryClient.setQueryData(contentListQueries.getModules({ extra: module.extra }).queryKey, (oldData) => oldData?.filter((oldModule) => oldModule.id !== module.id));
        },
        onError: (error) => {
            const message = (isApiValidationError(error) && t(`error_codes.${error.extra.errorCode}`)) ||
                t('content_list.delete_module.error');
            Toast.show({ type: 'danger', message });
            setShowDeleteConfirmation(false);
        }
    });
    function handleShowDeleteConfirmation() {
        setShowDeleteConfirmation(true);
        DispatchDatahubEvents.clickContentModuleDeleteSchema(module);
    }
    function handleCloseDeleteConfirmation() {
        setShowDeleteConfirmation(false);
    }
    return {
        deleteMutation,
        showDeleteConfirmation,
        handleShowDeleteConfirmation,
        handleCloseDeleteConfirmation
    };
}
